import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=3afe3c62&scoped=true"
import script from "./receive.vue?vue&type=script&lang=js"
export * from "./receive.vue?vue&type=script&lang=js"
import style0 from "./receive.vue?vue&type=style&index=0&id=3afe3c62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe3c62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afe3c62')) {
      api.createRecord('3afe3c62', component.options)
    } else {
      api.reload('3afe3c62', component.options)
    }
    module.hot.accept("./receive.vue?vue&type=template&id=3afe3c62&scoped=true", function () {
      api.rerender('3afe3c62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg-admin/receive.vue"
export default component.exports